import { useEffect, useState } from "react";
import { Grid, Typography } from "@mui/material";
import Title from "../../../common/Title";
import { IChargebackLimitFields } from "@/Settings/types/Common/model";
import SmartSelector from "@/Layouts/components/InputComponents/SmartSelector";
import { updateSystemSettings } from "@/Settings/api/SystemSettings/mutations";
import { errorLogger } from "@/Common/helpers/logger";
import { useMutation } from "@tanstack/react-query";
import { useSelector } from "react-redux";
import { RootState } from "@/redux/store";

const data = [
	{ key: "0", value: "\ua74e" },
	{ key: "6", value: "6" },
	{ key: "12", value: "12" },
	{ key: "15", value: "15" },
	{ key: "18", value: "18" },
	{ key: "21", value: "21" },
	{ key: "24", value: "24" },
	{ key: "27", value: "27" },
	{ key: "30", value: "30" },
	{ key: "33", value: "33" },
	{ key: "36", value: "36" },
	{ key: "39", value: "39" },
	{ key: "42", value: "42" },
	{ key: "45", value: "45" },
	{ key: "48", value: "48" },
	{ key: "51", value: "51" },
	{ key: "54", value: "54" },
	{ key: "57", value: "57" },
	{ key: "60", value: "60" },
	{ key: "63", value: "63" },
	{ key: "66", value: "66" },
	{ key: "69", value: "69" },
	{ key: "72", value: "72" },
];

const ChargeBackLimits = (props: { locationId: string; position: string; chargebackLimits?: IChargebackLimitFields[] }) => {
	const { locationId, position, chargebackLimits = [] } = props;
	const user = useSelector((state: RootState) => state.user.user);
	const [selectedChargebackLimits, setSelectedChargebackLimits] = useState<string | null>(null);

	const { mutate, isPending } = useMutation({
		mutationFn: (input: { chargebackLimits: { position: string; value: string; lastModifiedBy: string; lastModifiedOn: Date }[] }) =>
			updateSystemSettings(locationId, input, "Chargeback Limits"),
		onError: (error) => errorLogger(error),
	});

	const handleChange = (selected: { key: string; value: string } | null) => {
		if (selected) {
			setSelectedChargebackLimits(selected.value);
			const isPreviousConfigured = chargebackLimits.some((entry) => entry.position === position);
			const updatedChargeBackLimits = chargebackLimits.map((entry) => {
				if (entry.position === position) {
					return {
						position,
						value: selected.value,
						lastModifiedBy: user?._id ?? "",
						lastModifiedOn: new Date(),
					};
				}
				return { ...entry, lastModifiedBy: entry?.lastModifiedBy?._id ?? "" };
			});

			if (!isPreviousConfigured) {
				const newEntry = {
					position,
					value: selected.value,
					lastModifiedBy: user?._id ?? "",
					lastModifiedOn: new Date(),
				};
				updatedChargeBackLimits.push(newEntry);
			}

			mutate({ chargebackLimits: updatedChargeBackLimits });
		}
	};

	useEffect(() => {
		setSelectedChargebackLimits(chargebackLimits?.find((entry) => entry.position === position)?.value ?? null);
		return () => {
			setSelectedChargebackLimits(null);
		};
	}, []);

	return (
		<Grid container direction="column">
			<Title title="Chargeback Limit" className="!mb-[24px]" />
			<Grid item>
				<Grid container direction="row">
					<Grid item>
						<SmartSelector
							showBy={"value"}
							selectBy={"key"}
							options={data}
							selected={selectedChargebackLimits}
							inputProps={{
								placeholder: "Select...",
							}}
							listBoxProps={{
								sx: { maxHeight: "220px" },
							}}
							disabled={isPending}
							sx={{ minWidth: "140px" }}
							onChangeAction={(value) => handleChange(value as { key: string; value: string })}
						/>
					</Grid>
					<Grid item>
						<Typography className={"regular-pt-sans-pro-narrow-label"} sx={{ paddingTop: "5px", paddingLeft: "45px" }}>
							Months
						</Typography>
					</Grid>
				</Grid>
			</Grid>
		</Grid>
	);
};

export default ChargeBackLimits;
